import moment from 'moment';

export const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    sorter: (a, b) => a?.id - b?.id,
  },
  {
    title: 'Producto',
    dataIndex: 'product',
    sorter: {
      compare: (a, b) => {
        a = a?.product.toLowerCase();
        b = b?.product.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: 'Nombre del producto',
    dataIndex: 'name',
    sorter: {
      compare: (a, b) => {
        a = a?.name.toLowerCase();
        b = b?.name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: 'Precio',
    sorter: (a, b) => Number(a?.amount) - Number(b?.amount),
    render: elm => `$${elm?.amount}`,
  },
  {
    title: 'Fecha de pago',
    render: elm => moment(elm.transacted_at).format('DD/MM/YYYY'),
    sorter: (a, b) => moment(a?.transacted_at).valueOf() - moment(b?.transacted_at).valueOf(),
  },
  {
    title: 'Pagado por',
    sorter: {
      compare: (a, b) => {
        a = a?.user?.first_name.toLowerCase();
        b = b?.user?.first_name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
    render: elm => ` ${elm?.user?.first_name} ${elm?.user?.last_name}`,
  },
];
